import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import { DatePicker } from 'antd'
import moment from 'moment'
import { Alert } from 'syngenta-digital-cropwise-react-ui-kit'
import { WizardStepSubTitle } from '../subviews/WizardStepSubTitle'
import { WizardStepProps } from 'models'
import { DateTime } from 'luxon'
import { TRANSLATIONS_AUTH_PARTNERS } from 'models/Integration'
import { useTranslation } from 'react-i18next'

const SelectDateView = ({ step, integration, setDisableNextBtn }: WizardStepProps) => {
    const dateFormat = 'YYYY-MM-DD'
    const dateDisplayFormat = 'MM/DD/YYYY'
    const settings = integration?.settings
    const [sourceType, setSourceType] = useState('observation')
    const startDateRef = useRef(settings.start_time)
    const { t } = useTranslation()

    useEffect(() => {
        if (TRANSLATIONS_AUTH_PARTNERS.includes(integration?.partner_id!)) {
            setSourceType('translation')
        }
    }, [integration])

    useEffect(() => {
        setDisableNextBtn(!startDateRef.current)
    }, [settings.start_time, setDisableNextBtn])

    const getTodayUTCDate = () => {
        let dt = DateTime.utc()
        return DateTime.utc(dt.year, dt.month, dt.day, 0, 0)
    }

    const getDefaultDate = () => {
        let defaultDate = settings.start_time
        if (!settings.start_time) {
            if (TRANSLATIONS_AUTH_PARTNERS.includes(integration?.partner_id!)) {
                defaultDate = getTodayUTCDate().plus({ days: -365 }).toString()
            } else {
                defaultDate = getTodayUTCDate().toString()
            }
        }
        integration?.updateIntegrationStartDate(defaultDate)
        startDateRef.current = defaultDate
        return defaultDate
    }

    const onChange = (_date: any, dateString: string) => {
        if (integration) {
            let dt = DateTime.fromFormat(dateString, 'MM/dd/yyyy')
            dt = DateTime.utc(dt.year, dt.month, dt.day, 0, 0)
            startDateRef.current = dt.toString()
            integration?.updateIntegrationStartDate(dt.toString())
        }
    }
    const disableDate = (currentDate: any) =>
        new Date(currentDate._d).getTime() > getTodayUTCDate().toMillis()

    const DateFieldHint = () => {
        if (step.jobFrequency && step.jobFrequency === 'DAILY') {
            return <small className='mt-24'>{t('Integration.daily_day')}</small>
        }
        return <small className='mt-24'>{t('Integration.daily_hour')}</small>
    }

    return <section className='h-100% flex flex-col items-start'>
        {step.subTitle && <WizardStepSubTitle subTitle={step.subTitle} />}
        <div data-cy='wizard-date-comp' className='w-55% min-w-250 min-h-0 mx-auto'>
            <fieldset className='flex flex-col items-start w-100% my-20'>
                <label htmlFor='select-date' className='text-left w-100%'>{t('Integration.start_date')}</label>
                <DatePicker data-cy='select-date' id='select-date' format={dateDisplayFormat}
                    defaultValue={moment(getDefaultDate(), dateFormat)} onChange={onChange}
                    disabledDate={disableDate}
                    allowClear={false} className='w-100%' />
                <DateFieldHint />
                <Alert type='warning'
                    showIcon={true}
                    style={{ border: 'none' }}
                    className='text-left flex flex-row items-center w-100% my-24 rounded-10'
                    message={`Any ${sourceType} data created before this date will NOT be imported.`} />
            </fieldset>
        </div>
    </section>
}
export default observer(SelectDateView)
